import React from 'react';
import { useNode } from '@craftjs/core';
import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledAccordion = withStyles({
  root: {
    background: 'transparent',
    boxShadow: 'none',
    '&:before': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&$expanded': {
      margin: 0,
      minHeight: '40px',
      '&:before': {
        opacity: '1',
      },
    },
  },
  expanded: {}, 
})(MuiAccordion);

const StyledAccordionSummary = withStyles({
  root: {
    minHeight: '36px',
    padding: 0,
    '&$expanded': {
      minHeight: '36px',
    },
  },
  content: {
    margin: '0 !important',
    width: '100%',
    '&$expanded': {
      margin: '0 !important',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const useStyles = makeStyles((theme) => ({
  summaryContainer: {
    padding: theme.spacing(0, 3),
    width: '100%',
  },
  title: {
    fontSize: '11px',
    fontWeight: 500,
    textAlign: 'left',
  },
  summary: {
    fontSize: '11px',
    color: theme.palette.primary.main,
    textAlign: 'right',
  },
  details: {
    padding: theme.spacing(0, 3, 2.5),
  },
}));

export const ToolbarSection = ({ title, props, summary, children }) => {
  const classes = useStyles();
  const { nodeProps } = useNode((node) => ({
    nodeProps:
      props &&
      props.reduce((res, key) => {
        res[key] = node.data.props[key] || null;
        return res;
      }, {}),
  }));

  return (
    <StyledAccordion defaultExpanded>
      <StyledAccordionSummary>
        <div className={classes.summaryContainer}>
          <Grid container direction="row" alignItems="center" spacing={3}>
            <Grid item xs={4}>
              <Typography className={classes.title}>{title}</Typography>
            </Grid>
            {summary && nodeProps && (
              <Grid item xs={8}>
                <Typography className={classes.summary}>
                  {summary(nodeProps)}
                </Typography>
              </Grid>
            )}
          </Grid>
        </div>
      </StyledAccordionSummary>
      <AccordionDetails className={classes.details}>
        <Grid container spacing={1}>
          {children}
        </Grid>
      </AccordionDetails>
    </StyledAccordion>
  );
};